module.exports = __webpack_public_path__ + "20260128d142218t/img/newhands-icon.2d9c01eb.png";